module.exports = __webpack_public_path__ + "img/prefecture.e0e0e814.jpg";